
import React from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface OrganizationErrorCardProps {
  error: string | null;
}

export function OrganizationErrorCard({ error }: OrganizationErrorCardProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-6">
        <Building2 className="h-10 w-10 text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold mb-2">Organization Not Found</h3>
        <p className="text-muted-foreground mb-4 text-center">
          {error || "The organization you're looking for doesn't exist or you don't have access to it."}
        </p>
        <Button asChild>
          <Link to="/organizations">Back to Organizations</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
